export default __webpack_public_path__ + "897f805f3a6104f50449b0b63f921ce9.png";